// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__zY3kE","header":"Navbar_header__hZBJu","categories":"Navbar_categories__eG7hS","display":"Navbar_display__VG2sn","noDisplay":"Navbar_noDisplay__7x3xM"};